/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		marginTop: 24,
		borderWidth: 1,
		borderColor: borderColor,
	},

	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		minHeight: 30,
		alignItems: 'stretch', // better alignment
	},

	headerCell: {
		fontSize: 9,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: '#ffffff',
		justifyContent: 'center',
		display: 'flex',
		textAlign: 'center',
	},

	name: {
		width: '18%',
		textAlign: 'left',
	},

	regionInfo: {
		width: '16%',
		textAlign: 'left',
	},

	pipelineChainage: {
		width: '24%',
		textAlign: 'center',
	},

	assettypeId: {
		width: '16%',
		textAlign: 'center',
	},

	remarks: {
		width: '16%',
		textAlign: 'left',
	},

	status: {
		width: '10%',
		textAlign: 'center',
		borderRightWidth: 0, // last column no border
	},
});

const paginate = (array, perPage) => {
	const pages = [];

	for (let i = 0; i < array.length; i += perPage) {
		pages.push(array.slice(i, i + perPage));
	}

	return pages;
};

const InvoiceItemsTable = (props) => {
	const itemsPerPage = 10;
	const pages = paginate(props.invoice || [], itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>
					
					{/* break only after first page */}
					{pageIndex > 0 && <View break />}

					<View wrap>
						{/* Header */}
						<View style={styles.container}>

							<Text style={[styles.headerCell, styles.name]}>
								Name
							</Text>

							<Text style={[styles.headerCell, styles.regionInfo]}>
								Region
							</Text>

							<Text style={[styles.headerCell, styles.pipelineChainage]}>
								Pipeline Chainage
							</Text>

							<Text style={[styles.headerCell, styles.assettypeId]}>
								Asset Type
							</Text>

							<Text style={[styles.headerCell, styles.remarks]}>
								Remarks
							</Text>

							<Text style={[styles.headerCell, styles.status]}>
								Status
							</Text>

						</View>

						{/* Rows */}
						<InvoiceTableRow data={pageData} />
					</View>
				</React.Fragment>
			))}
		</>
	);
};

export default InvoiceItemsTable;